import { supabase } from "@/integrations/supabase/client";
import { handleSupabaseFunctionError } from "@/utils/supabaseFunctionsError";
import type {
  AplicaTargetareSnapshotRequest,
  AplicaTargetareSnapshotResponse,
  GetTargetareNomenclatoareResponse,
  GetTargetareSetariResponse,
  GetTargetareSnapshotDiferenteResponse,
  GetTargetareSnapshotJobResponse,
  GetTargetareSnapshoturiResponse,
  GetTargetareTermeneStatsResponse,
  RevinoTargetareSnapshotResponse,
  SalveazaTargetareSetareRequest,
  SalveazaTargetareSetareResponse,
} from "@/api/types/targetareDate";

function assertSuccess(data: unknown, endpoint: string): void {
  if (
    !data ||
    typeof data !== "object" ||
    (data as { success?: unknown }).success !== true
  ) {
    throw new Error(`Răspuns invalid de la ${endpoint}`);
  }
}

async function apel<T>(
  cale: string,
  method: "GET" | "POST",
  body?: unknown
): Promise<T> {
  const { data, error } = await supabase.functions.invoke(
    `api/targetare/${cale}`,
    body === undefined ? { method } : { method, body }
  );
  await handleSupabaseFunctionError(error);
  assertSuccess(data, `targetare/${cale}`);
  return data as T;
}

export const getTargetareSnapshoturi = () =>
  apel<GetTargetareSnapshoturiResponse>("date/snapshoturi", "GET");

export const getTargetareSnapshotDiferente = (id: number) =>
  apel<GetTargetareSnapshotDiferenteResponse>(
    `date/snapshoturi/${id}/diferente`,
    "GET"
  );

export const getTargetareSnapshotJob = (id: number) =>
  apel<GetTargetareSnapshotJobResponse>(`date/snapshoturi/${id}/job`, "GET");

export const aplicaTargetareSnapshot = (
  cerere: AplicaTargetareSnapshotRequest
) =>
  apel<AplicaTargetareSnapshotResponse>(
    `date/snapshoturi/${cerere.id}/aplica`,
    "POST",
    { forta: cerere.forta ?? false }
  );

export const revinoTargetareSnapshot = (id: number) =>
  apel<RevinoTargetareSnapshotResponse>(
    `date/snapshoturi/${id}/revino`,
    "POST",
    {}
  );

export const getTargetareSetari = () =>
  apel<GetTargetareSetariResponse>("date/setari", "GET");

export const salveazaTargetareSetare = (
  cerere: SalveazaTargetareSetareRequest
) => apel<SalveazaTargetareSetareResponse>("date/setari", "POST", cerere);

export const getTargetareNomenclatoare = () =>
  apel<GetTargetareNomenclatoareResponse>("date/nomenclatoare", "GET");

export const getTargetareTermeneStats = () =>
  apel<GetTargetareTermeneStatsResponse>("date/termene-stats", "GET");
